<template>
  <div>
    <div class="active-event-title">
      <span class="event-title">Događanja</span>
      <span class="in-progress">U TIJEKU</span>
    </div>
    <div class="description">
      <div v-for="activeEvent in activeEvents" v-bind:key="activeEvent.id">
        <span v-if="activeEvent.type">{{ translateType(activeEvent.type) }} : </span>
        <span v-if="activeEvent.name">{{ activeEvent.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplicationActiveEvent',
  props: {
    activeEvents: [],
  },
  methods: {
    translateType: function (type) {
      if (type === 'Lecture') return 'Predavanje';

      if (type === 'Workshop') return 'Radionica';

      if (type === 'FlyTalk') return 'Fly Talk';
  
      return 'Ostalo';
    },
  },
};
</script>

<style scoped>
.active-event-title {
  display: flex;
  align-items: center;
}

.event-title {
  font-family: 'Fuse V.2 Display';
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 36px;
  color: #ffffff;
}
.in-progress {
  display: inline-block;
  border: 1px solid #d73246;
  border-radius: 6px;
  color: #d73246;
  font-family: 'Fuse V.2 Display';
  font-style: normal;
  font-weight: 800;
  font-size: 12px;
  padding: 2px 8px;
  line-height: 12px;
  margin-left: 8px;
}

@keyframes pulse-red {
  0% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
  }

  100% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
  }
}

.in-progress::before {
  content: '';
  background-color: #d73246;
  display: inline-block;
  border-radius: 50%;
  width: 8px;
  height: 8px;
  margin-right: 4px;
  animation: pulse-red 2s infinite;
}

.description {
  font-family: 'Fuse V.2 Display';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.8);
}
</style>